<template>
    <Table
        ref="table"
        :data="customers"
        :loading="loading"
        :pagination="pagination"
        :columns="columns"
        :custom-row="customRow"
        @change="handleTableChange"
    />
</template>

<script>
import Table from './Table';
import tableMixin from '@/mixins/tableMixin';

export default {
    name: 'CustomerTable',
    components: {
        Table,
    },
    mixins: [tableMixin('customers')],
    props: {
        customers: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        pagination: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    data() {
        return {
            columns: [
                this.columnFor('name', { sortable: false }),
                this.columnFor('contactPerson', { filterable: false, sortable: false }),
                this.columnFor('email', { filterable: false, sortable: false }),
                this.columnFor('createdAt', {
                    filterable: false,
                    sortable: false,
                    customRender: this.$formatDate,
                }),
            ],
        };
    },
};
</script>

<style>
</style>
